export enum AlertType {
  success = "success",
  warning = "warning",
  error = "error",
  info = "info",
}
